import styled from "styled-components";
import { HealthContactFormContainer } from "../../../health/forms/contact-item/contact-form-item-style";

export const ForeignersHealthContactContainer = styled(HealthContactFormContainer)``;
